// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { SubmissionError } from 'redux-form'
import { formatErrorData } from 'helpers/reduxFormFunctions'

// NOTE - This needs to be called within a redux-form submit submit handler to work properly.

// NOTE - <SubmitErrors /> is meant to be used in conjunction with this function.
// however, this also provides a fallback for your everyday
// redux-form error handling via the _error property.

const throwSubmissionError = err => {
  const error = formatErrorData(err)
  throw new SubmissionError(error)
}

export default throwSubmissionError
